import moment from 'moment';
import { createSelector } from 'reselect';

const getMasses = state => state.masses.masses;

const getMassesByDay = createSelector(getMasses, masses => {
  return masses.reduce((acc, mass) => {
    const date = moment(mass.massDate).format('YYYY-MM-DD');

    if (!acc[date]) {
      acc[date] = [];
    }

    acc[date].push(mass);

    return acc;
  }, {});
});

const getMassesForDay = selectedDate =>
  createSelector(getMassesByDay, massesByDay => {
    const formattedDate = selectedDate.format('YYYY-MM-DD');

    if (massesByDay[formattedDate]) {
      return massesByDay[formattedDate];
    }

    return [];
  });

const getSelectedMassId = state => state.masses.selectedMassId;

const getSelectedMass = createSelector(getMasses, getSelectedMassId, (masses, massId) =>
  masses.find(mass => mass.id === massId),
);

const getSoonestMassWithFreeSlot = createSelector(getMasses, masses => {
  if (!masses) {
    return null;
  }
  const sortedMasses = [...masses].sort((a, b) => moment(a.massDate).diff(moment(b.massDate)));

  const mass = sortedMasses.find(m => {
    return (
      (m.hasUnlimitedOfferings || m.availableMassOfferings > 0) &&
      m.unavailableBecauseOfMinimumFromDate === false &&
      m.unavailableBecauseOfEvenDistribution === false
    );
  });

  if (mass) {
    return mass;
  }

  return null;
});

const massesSelectors = {
  getSoonestMassWithFreeSlot,
  getMassesByDay,
  getMassesForDay,
  getSelectedMassId,
  getSelectedMass,
};

export default massesSelectors;
